import { BackendTier } from "../web-apis/backends";
import _ from "lodash";

export type DeploymentConfigInfo = {
    backendUrl: string;
    backendTier: BackendTier;
    backendName?: string;
    regionInfo?: string;
    regionLicenseUrl?: string;
    allowModelSelectionTextEntry: boolean;
    supportContactInformation?: string;
    isDemo: boolean;
}

/** Default values for "non-optional" optional settings. */
const defaultOptions = {
    allowModelSelectionTextEntry: false,
    isDemo: false,
};

export const generateDeploymentConfigInfo = (jsonObject: any): DeploymentConfigInfo | undefined => {
    if ('backendUrl' in jsonObject && 'backendTier' in jsonObject && Object.values(BackendTier).includes(jsonObject['backendTier'])) {
        const deploymentConfigInfo: DeploymentConfigInfo = { backendUrl: jsonObject['backendUrl'], backendTier: jsonObject['backendTier'], ...defaultOptions }
        if ('backendName' in jsonObject) {
            deploymentConfigInfo.backendName = jsonObject['backendName'];
        }
        if ('regionInfo' in jsonObject) {
            deploymentConfigInfo.regionInfo = jsonObject['regionInfo'];
        }
        if ('regionLicenseUrl' in jsonObject) {
            deploymentConfigInfo.regionLicenseUrl = jsonObject['regionLicenseUrl'];
        }
        if ('allowModelSelectionTextEntry' in jsonObject && _.isBoolean(jsonObject['allowModelSelectionTextEntry'])) {
            deploymentConfigInfo.allowModelSelectionTextEntry = jsonObject['allowModelSelectionTextEntry'];
        }
        if ('supportContactInformationMarkdown' in jsonObject) {
            deploymentConfigInfo.supportContactInformation = jsonObject['supportContactInformationMarkdown'];
        }
        if ('isDemo' in jsonObject) {
            deploymentConfigInfo.isDemo = jsonObject['isDemo'];
        }
        return deploymentConfigInfo;
    }

    return undefined;
}
